import React, { Fragment, useState } from 'react';
import { UPDATE, GET_MANY } from 'ra-core';
import { Button, useDataProvider, useTranslate, useRecordContext } from 'react-admin';
import MUIButton from '@mui/material/Button';
import HistoryIcon from '@mui/icons-material/History';
import ErrorIcon from '@mui/icons-material/Error';
import CheckIcon from '@mui/icons-material/CheckCircle';
import { useSnackbar } from 'notistack';
import { FUNCTION_URL } from '../../../Constants/index';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function ResetButton() {
    const [isOpen, setIsOpen] = useState(false);
    const dataProvider = useDataProvider();
    const { enqueueSnackbar } = useSnackbar();
    const translate = useTranslate();
    const record = useRecordContext();

    const handleClick = () => {
        setIsOpen(true);
    }

    const handleDialogClose = () => {
        setIsOpen(false);
    };

    const handleConfirm = async () => {
        setIsOpen(false);
        let devices = [record];
        let promisesArray = [];
        let recoverWRArray = [];

        if (record.status.codice === '12') {
            //get all associated devices to the same task
            devices = await dataProvider(GET_MANY, 'devices', { "filter": { workrequestid: record.workrequestid, cod_terr_sap: 'GetAll' } })
                .then(
                    async response => {
                        return response.total ? response.data : undefined;
                    })
                .catch(error => {
                    console.log(error);
                    return undefined;
                });
        }

        for (const device of devices) {
            let workrequestid = device.workrequestid;
            let requestingDevice = device.serial_number_tim;

            let updateProps = {
                id: device.id,
                data: {
                    status: {
                        codice: device.cod_terr_sap.startsWith("IB") ? '6' : '1',
                    },
                    $unset: {
                        anomalia: '',
                        externalrefid: '',
                        workrequestid: '',
                        impianto: '',
                        codice_impresa_name: '',
                        tipo_task: '',
                        wr_prodotti: '',
                        cod_proj: '',
                        client_type: '',
                        resource_id: '',
                        causale: '',
                        area: '',
                        reverse: '',
                        associated_at: '',
                        associated_by: '',
                        validated_by: '',
                        validated_at: '',
                        serial_number_cpe: '',
                        lista_NMU: '',
                        data_completamento_wr: '',
                        descrizione_impresa: '',
                        check_NMU: '',
                        flag_olo: '',
                        codice_isp: '',
                        tsys: '',
                        check_u0009t: '',
                        importo_u0009t: '',
                        progetto_con_scarico: '',
                        data_primo_reject: '',
                        data_ultimo_reject: '',
                        contatore: '',
                        codice_riscontro: '',
                        post_delivery: '',
                        tipo_inserimento: '',
                        blinda_scarico_mat: '',
                        proprieta_materiale: '',
                        one_step: '',
                        aclrr: '',
                        desc_tp_diagnosi: '',
                        equivalenza_prod_applicabile: ''
                    }
                },
                previousData: device
            };

            /** TO_SM_402
             * La funzione disassocia non aggiorna il campo relativo al CheckCollaudoOne in caso di CheckCollaudo one Ok o Check Collaudo One KO. Dovrebbe aggiornarli in DISCOVERATO SU COLLAUDO ONE
             */
            if (device.status_collaudo_one && ['2','3'].includes(device.status_collaudo_one.codice)) updateProps.data.status_collaudo_one = { codice: '1' };

            /*TO_SM_134 - status_regman is set depending on how it was set before:
                if it was set by the service that sets serial_number_cpe, it will be NO DISCOVERATO
                if not but it was by the tool and was OK or KO, it will be DISCOVERATO SU REGMAN
            */
            if (device.serial_number_cpe) {
                updateProps.data.status_regman = { codice: '0' };
            }
            else if (device.status_regman && ['2', '3'].includes(device.status_regman.codice)) {
                updateProps.data.status_regman = { codice: '1' };
            }

            //ES037 - Log in wr_history if this task has been rejected 
            if (device.contatore && device.wr_history) {
                updateProps.data.wr_history = device.wr_history;
                let found_wr = false;

                for (let i = 0; i < device.wr_history.length; i++) {
                    if (device.wr_history[i].wr === device.workrequestid) {
                        found_wr = true;
                        updateProps.data.wr_history[i].wr_data_ultimo_reject = device.data_ultimo_reject;
                        updateProps.data.wr_history[i].wr_contatore = device.contatore;
                    }
                }

                if (!found_wr) {
                    updateProps.data.wr_history.push({
                        wr: device.workrequestid,
                        wr_data_primo_reject: device.data_primo_reject,
                        wr_data_ultimo_reject: device.data_ultimo_reject,
                        wr_contatore: device.contatore
                    })
                }
            }
            else if (device.contatore) {
                updateProps.data.wr_history = [{
                    wr: device.workrequestid,
                    wr_data_primo_reject: device.data_primo_reject,
                    wr_data_ultimo_reject: device.data_ultimo_reject,
                    wr_contatore: device.contatore
                }]
            }

            promisesArray.push(dataProvider(UPDATE, 'devices', updateProps))
            recoverWRArray.push({ workrequestid: workrequestid, requestingDevice: requestingDevice });
        }

        Promise.all(promisesArray).then(result => {
            console.log(" Promise all response", result);

            result.forEach((response, i) => {
                if (response.data.error) {
                    //Ex: Invalid cast Id
                    console.log(response.data.error.message);
                    enqueueSnackbar(translate('tim.reset.error'), {
                        variant: 'error',
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        },
                        autoHideDuration: 3000,
                    });
                }
                else if (response.data.message && response.data.message === "Updated") {
                    enqueueSnackbar(translate('tim.reset.deleted'), {
                        variant: 'success',
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        },
                        autoHideDuration: 3000,
                    });
                    // window.location.replace(window.location.origin + '/#/devices');
                    // window.location.reload();

                    fetch(FUNCTION_URL + '/recoverwr/' + recoverWRArray[i].workrequestid, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'text/plain',
                            'x-zumo-auth': localStorage.getItem('auth-token')
                        },
                        body: JSON.stringify({ serial_number_tim: recoverWRArray[i].requestingDevice })
                    })
                        .catch(error => {
                            console.log(error);
                        });
                }
            })
            window.location.replace(window.location.origin + '/#/devices');
        })
            .catch(error => {
                console.log(error);
                enqueueSnackbar(translate('tim.reset.error'), {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    autoHideDuration: 3000,
                });
            });
    };
    
        return (
            <Fragment>
                <MUIButton label='tim.reset.button_label' onClick={handleClick} color="red">
                    <HistoryIcon />
                    {translate('tim.reset.button_label')}
                </MUIButton>
                <Dialog
                    open={isOpen}
                    onClose={handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{translate('tim.reset.title', { name: record.serial_number_tim })}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {record.status.codice === '12' ? translate('tim.reset.contentDaScaricare') : translate('tim.reset.content')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose} label='tim.reset.cancel' color="primary" autoFocus>
                            <ErrorIcon />
                        </Button>
                        <Button onClick={handleConfirm} label='tim.reset.confirm' color="primary" autoFocus>
                            <CheckIcon />
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
}
export default ResetButton;